import { useContext } from 'react';

import type { GetCreditCardApplicationsUtils } from 'src/contexts/creditCardApplicationsContext/GetCreditCardApplicationsContext';
import GetCreditCardApplicationsContext from 'src/contexts/creditCardApplicationsContext/GetCreditCardApplicationsContext';

export const useGetCreditCardApplicationUtils = (): GetCreditCardApplicationsUtils => useContext(GetCreditCardApplicationsContext);
